module.exports = __webpack_public_path__ + "img/advantages_5.c246d057.svg";